import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var _mediaController, _delay, _style;

import { MediaUIAttributes, MediaStateReceiverAttributes } from "./constants.js";
import { nouns } from "./labels/labels.js";
import { globalThis, document } from "./utils/server-safe-globals.js";
import { getBooleanAttr, setBooleanAttr, getOrInsertCSSRule } from "./utils/element-utils.js";
var Attributes = {
  LOADING_DELAY: "loadingdelay"
};
var DEFAULT_LOADING_DELAY = 500;
var template = document.createElement("template");
var loadingIndicatorIcon = "\n<svg aria-hidden=\"true\" viewBox=\"0 0 100 100\">\n  <path d=\"M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50\">\n    <animateTransform\n       attributeName=\"transform\"\n       attributeType=\"XML\"\n       type=\"rotate\"\n       dur=\"1s\"\n       from=\"0 50 50\"\n       to=\"360 50 50\"\n       repeatCount=\"indefinite\" />\n  </path>\n</svg>\n";
template.innerHTML = "\n<style>\n:host {\n  display: var(--media-control-display, var(--media-loading-indicator-display, inline-block));\n  vertical-align: middle;\n  box-sizing: border-box;\n  --_loading-indicator-delay: var(--media-loading-indicator-transition-delay, ".concat(DEFAULT_LOADING_DELAY, "ms);\n}\n\n#status {\n  color: rgba(0,0,0,0);\n  width: 0px;\n  height: 0px;\n}\n\n:host slot[name=icon] > *,\n:host ::slotted([slot=icon]) {\n  opacity: var(--media-loading-indicator-opacity, 0);\n  transition: opacity 0.15s;\n}\n\n:host([").concat(MediaUIAttributes.MEDIA_LOADING, "]:not([").concat(MediaUIAttributes.MEDIA_PAUSED, "])) slot[name=icon] > *,\n:host([").concat(MediaUIAttributes.MEDIA_LOADING, "]:not([").concat(MediaUIAttributes.MEDIA_PAUSED, "])) ::slotted([slot=icon]) {\n  opacity: var(--media-loading-indicator-opacity, 1);\n  transition: opacity 0.15s var(--_loading-indicator-delay);\n}\n\n:host #status {\n  visibility: var(--media-loading-indicator-opacity, hidden);\n  transition: visibility 0.15s;\n}\n\n:host([").concat(MediaUIAttributes.MEDIA_LOADING, "]:not([").concat(MediaUIAttributes.MEDIA_PAUSED, "])) #status {\n  visibility: var(--media-loading-indicator-opacity, visible);\n  transition: visibility 0.15s var(--_loading-indicator-delay);\n}\n\nsvg, img, ::slotted(svg), ::slotted(img) {\n  width: var(--media-loading-indicator-icon-width);\n  height: var(--media-loading-indicator-icon-height, 100px);\n  fill: var(--media-icon-color, var(--media-primary-color, rgb(238 238 238)));\n  vertical-align: middle;\n}\n</style>\n\n<slot name=\"icon\">").concat(loadingIndicatorIcon, "</slot>\n<div id=\"status\" role=\"status\" aria-live=\"polite\">").concat(nouns.MEDIA_LOADING(), "</div>\n");

var MediaLoadingIndicator = /*#__PURE__*/function (_globalThis$HTMLEleme) {
  _inherits(MediaLoadingIndicator, _globalThis$HTMLEleme);

  var _super = _createSuper(MediaLoadingIndicator);

  function MediaLoadingIndicator() {
    var _this;

    _classCallCheck(this, MediaLoadingIndicator);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _mediaController, void 0);

    __privateAdd(_assertThisInitialized(_this), _delay, DEFAULT_LOADING_DELAY);

    __privateAdd(_assertThisInitialized(_this), _style, void 0);

    if (!_this.shadowRoot) {
      var shadow = _this.attachShadow({
        mode: "open"
      });

      var indicatorHTML = template.content.cloneNode(true);
      shadow.appendChild(indicatorHTML);
    }

    var _getOrInsertCSSRule = getOrInsertCSSRule(_this.shadowRoot, ":host"),
        style = _getOrInsertCSSRule.style;

    __privateSet(_assertThisInitialized(_this), _style, style);

    return _this;
  }

  _createClass(MediaLoadingIndicator, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      var _a, _b, _c, _d, _e;

      if (attrName === Attributes.LOADING_DELAY && oldValue !== newValue) {
        this.loadingDelay = Number(newValue);
      } else if (attrName === MediaStateReceiverAttributes.MEDIA_CONTROLLER) {
        if (oldValue) {
          (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

          __privateSet(this, _mediaController, null);
        }

        if (newValue && this.isConnected) {
          __privateSet(this, _mediaController, (_c = this.getRootNode()) == null ? void 0 : _c.getElementById(newValue));

          (_e = (_d = __privateGet(this, _mediaController)) == null ? void 0 : _d.associateElement) == null ? void 0 : _e.call(_d, this);
        }
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _a, _b, _c;

      var mediaControllerId = this.getAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);

      if (mediaControllerId) {
        __privateSet(this, _mediaController, (_a = this.getRootNode()) == null ? void 0 : _a.getElementById(mediaControllerId));

        (_c = (_b = __privateGet(this, _mediaController)) == null ? void 0 : _b.associateElement) == null ? void 0 : _c.call(_b, this);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _a, _b;

      (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

      __privateSet(this, _mediaController, null);
    }
  }, {
    key: "loadingDelay",
    get: function get() {
      return __privateGet(this, _delay);
    },
    set: function set(delay) {
      __privateSet(this, _delay, delay);

      __privateGet(this, _style).setProperty("--_loading-indicator-delay", "var(--media-loading-indicator-transition-delay, ".concat(delay, "ms)"));
    }
  }, {
    key: "mediaPaused",
    get: function get() {
      return getBooleanAttr(this, MediaUIAttributes.MEDIA_PAUSED);
    },
    set: function set(value) {
      setBooleanAttr(this, MediaUIAttributes.MEDIA_PAUSED, value);
    }
  }, {
    key: "mediaLoading",
    get: function get() {
      return getBooleanAttr(this, MediaUIAttributes.MEDIA_LOADING);
    },
    set: function set(value) {
      setBooleanAttr(this, MediaUIAttributes.MEDIA_LOADING, value);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [MediaStateReceiverAttributes.MEDIA_CONTROLLER, MediaUIAttributes.MEDIA_PAUSED, MediaUIAttributes.MEDIA_LOADING, Attributes.LOADING_DELAY];
    }
  }]);

  return MediaLoadingIndicator;
}(globalThis.HTMLElement);

_mediaController = new WeakMap();
_delay = new WeakMap();
_style = new WeakMap();

if (!globalThis.customElements.get("media-loading-indicator")) {
  globalThis.customElements.define("media-loading-indicator", MediaLoadingIndicator);
}

var media_loading_indicator_default = MediaLoadingIndicator;
export { Attributes, media_loading_indicator_default as default };